import QRCodeStyling from "./core/QRCodeStyling";
import dotTypes from "./constants/dotTypes";
import errorCorrectionLevels from "./constants/errorCorrectionLevels";
import errorCorrectionPercents from "./constants/errorCorrectionPercents";
import modes from "./constants/modes";
import qrTypes from "./constants/qrTypes";

export default QRCodeStyling;
export { dotTypes, errorCorrectionLevels, errorCorrectionPercents, modes, qrTypes };
